export const mobile = 768;
export const laptop = 1024;
export const desktop = 1536;
export const desktopL = 1920;
export const desktopXL = 2560;
export const television = 3840;
